/**
 * Vaultek Support Pages - Namespaced JavaScript
 * Scoped to .vaultek-support wrapper only
 * Handles WPBakery toggle/accordion functionality
 * Version: 2.0
 */

(function() {
  'use strict';

  // Only run if wrapper exists
  const wrapper = document.querySelector('.vaultek-support');
  if (!wrapper) return;

  /**
   * Initialize toggle/accordion functionality
   */
  function initToggles() {
    const toggles = wrapper.querySelectorAll('.vc_toggle, .vc_do_toggle');
    
    toggles.forEach(function(toggle) {
      const title = toggle.querySelector('.vc_toggle_title');
      if (!title) return;

      // Make title clickable
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');

      // Click handler
      title.addEventListener('click', function(e) {
        e.preventDefault();
        toggleAccordion(toggle, title);
      });

      // Keyboard handler (Enter and Space)
      title.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(toggle, title);
        }
      });
    });
  }

  /**
   * Toggle accordion open/closed state
   */
  function toggleAccordion(toggle, title) {
    const isActive = toggle.classList.contains('vc_toggle_active');
    
    if (isActive) {
      toggle.classList.remove('vc_toggle_active');
      title.setAttribute('aria-expanded', 'false');
    } else {
      toggle.classList.add('vc_toggle_active');
      title.setAttribute('aria-expanded', 'true');
    }
  }

  /**
   * Initialize smooth scroll for anchor links
   */
  function initSmoothScroll() {
    const anchors = wrapper.querySelectorAll('a[href^="#"]');
    
    anchors.forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          
          // Offset for fixed headers
          const headerOffset = 100;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          // Update URL without jumping
          history.pushState(null, null, targetId);
        }
      });
    });
  }

  /**
   * Handle hash links on page load
   */
  function handleHashOnLoad() {
    if (window.location.hash) {
      const target = document.querySelector(window.location.hash);
      if (target && wrapper.contains(target)) {
        setTimeout(function() {
          const headerOffset = 100;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }

  /**
   * Add hover effects to product images
   */
  function initImageEffects() {
    const productImages = wrapper.querySelectorAll('.img-thumbnail');
    
    productImages.forEach(function(img) {
      // Add loading="lazy" for images below the fold
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
    });
  }

  

  /**
   * Initialize all functionality
   */
  function init() {
    initToggles();
    initSmoothScroll();
    initImageEffects();
    handleHashOnLoad();
    
    

  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
